import { useEffect, useState } from 'react';

function parseBackendDate(dateString: string): Date {
  const [date, time] = dateString.split(' ');
  if (!date || !time) return new Date(dateString); // fallback
  const [hms, micro] = time.split('.');
  const ms = (micro || '000').slice(0, 3).padEnd(3, '0');
  return new Date(`${date}T${hms}.${ms}Z`);
}

function formatTimeAgo(dateString: string, now: number): string {
  const then = parseBackendDate(dateString).getTime();
  let diff = Math.floor((now - then) / 1000);
  if (diff < 0) diff = 0;
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function TimeAgo({ dateString }: { dateString: string }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);
  return <span className="text-xs text-gray-400">{formatTimeAgo(dateString, now)}</span>;
}
